export const SUB_ACCOUNT_HEADER = 'sub-account';

// APIs should be added sub-acc header.
export const ENABLED_SUB_ACCOUNT_HEADER_APIS = {
  // order
  'order/create': true,
  'order/cancel': true,
  'order/list/new': true,
  'order/list/create': true,
  'order/entrust_history': true,
  'trade/list_by_order': true,
  'order/cancel-all': true,
  'private/amend-order': true,
  // margin
  'margin/get-user-config': true,
  'margin/transfer': true,
  'margin/borrow': true,
  'margin/repay': true,
  'margin/get-transfer-history': true,
  'margin/get-borrow-history': true,
  'margin/get-repay-history': true,
  'margin/get-interest-history': true,
  'margin/get-liquidation-history': true,
  'margin/get-liquidation-orders-entrust': true,
  // balance
  'finance/v5/account_balance': true,
  'stable_coin_conversion/stable_coin_config_list': true,
  'stable_coin_conversion/convert': true,
  'admin_transfer/history': true,
  'stable_coin_conversion/conversion_history': true,
  'dust-conversion/all-dusts': true,
  'dust-conversion/conversion_history': true,
  'dust-conversion/conversions': true,
  // dashboard
  '/balance_history': true,
  // staking
  'record/staking_interest_history': true,
  'trading-fee/get-rebate-history': true,
  'soft-staking/interest-history': true,
  // API key management
  'api-key/api-key-list': true,
  'api-key/create-api-key': true,
  'api-key/update-api-key': true,
  'api-key/delete-api-key': true,
  // export history
  'batch/create-transaction-history-request': true,
  'batch/get-transaction-history-requests': true,
  'batch/download-transaction-history-request': true,
  // trading bot
  'trading-bots/create-trading-bot': true,
  'trading-bots/get-all-trading-bots-states': true,
  'trading-bots/update-trading-bot': true,
  'trading-bots/get-trading-bots': true,
  'trading-bots/get-trading-bot-pnl': true,
  'trading-bots/pause-trading-bot': true,
  'trading-bots/resume-trading-bot': true,
  'trading-bots/terminate-trading-bot': true,
  'trading-bots/get-trading-bot-executions': true,
  // trading bot v2
  'private/bot/get-trading-bot-pnl': true,
  'private/bot/get-trading-bots': true,
  'private/bot/create-trading-bot': true,
  'private/bot/get-dca-bot-params': true,
  'private/bot/get-grid-bot-params': true,
  'private/bot/get-all-trading-bots-states': true,
  'private/bot/update-trading-bot': true,
  'private/bot/pause-trading-bot': true,
  'private/bot/resume-trading-bot': true,
  'private/bot/get-trading-bot-executions': true,
  'private/bot/terminate-trading-bot': true,
  // otc
  'otc/get-instruments': true,
  'otc/get-quote': true,
  'otc/confirm-quote': true,
  'otc/get-quote-history': true,
  'otc/get-trade-history': true,
  'otc/accept-exchange-tc': true,
  'private/otc/request-deal': true,
  // oex
  'private/user-balance-history': true,
  'private/user-balance': true,
  'private/create-order': true,
  'private/cancel-order': true,
  'private/cancel-all-orders': true,
  'private/create-order-list': true,
  'private/cancel-order-list': true,
  'private/get-open-orders': true,
  'private/get-order-history': true,
  'private/get-loans': true,
  'private/get-positions': true,
  'private/close-position': true,
  'private/get-trades': true,
  'private/change-account-leverage': true,
  'private/get-account-info': true,
  'private/get-transactions': true,
  'private/get-risk-info': true,
  'private/create-subaccount-transfer': true,
  'private/get-dust-overview': true,
  'private/create-dust-quote': true,
  'private/confirm-dust-quote': true,
  // bff
  'feature-control': true,
  'private/balance/aggregate-balance': true,
  'private/balance/aggregate-balance-history': true,
  // statement
  'private/statement/journal-report/list': true,
  'private/statement/journal-report/download-summary': true,
  'private/statement/journal-report/get-details-download-url': true,
  'private/statement/trade-report/list': true,
  'private/statement/trade-report/download-summary': true,
  'private/statement/trade-report/get-details-download-url': true,
  // oto/otoco
  'private/advanced/create-oto': true,
  'private/advanced/create-oco': true,
  'private/advanced/create-otoco': true,
  'private/advanced/create-order': true,
  'private/advanced/cancel-oto': true,
  'private/advanced/cancel-oco': true,
  'private/advanced/cancel-otoco': true,
  'private/advanced/cancel-order': true,
  'private/advanced/cancel-all-orders': true,
  'private/advanced/get-open-orders': true,
  'private/advanced/get-order-detail': true,
  'private/advanced/get-order-history': true,
  'private/advanced/get-order-list-detail': true,
};

export const LABEL_REPLACE_MAP = {
  spot: ['_SPOT', '_1'],
  margin: ['_MARGIN', '_2'],
  deriv: ['_DERIVATIVES', '_3'],
};

export const FORMER_WALLET_TYPE_ID_MAP = {
  SPOT: 1,
  MARGIN: 2,
  DERIVATIVES: 3,
};
